<div class="main">
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>


<app-mp-snackbar></app-mp-snackbar>
